<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs();
const FORCHAT_LOGO = '/logoempresemfundoP.png';
const FORCHAT_NAME = 'Forchat';
</script>

<template>
  <img v-bind="attrs" :src="FORCHAT_LOGO" :alt="FORCHAT_NAME" />
</template>
